import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () =>
        import(
            /* webpackChunkName: "LazyCSPProgressedsChunk", webpackPreload: true */ './CSPProgressConnect'
        ),
    {
        fallback: <div>Loading...</div>,
    }
);
